import { createReactComponentFromLit } from '@affine/component';
import { DocTitle } from '@blocksuite/affine/fragments/doc-title';
import React from 'react';

import { DatabaseFullscreenEditor } from './database-fullscreen-editor';
import { EdgelessEditor } from './edgeless-editor';
import { PageEditor } from './page-editor';

export * from './database-fullscreen-editor';
export * from './edgeless-editor';
export * from './page-editor';

export const LitDocEditor = createReactComponentFromLit({
  react: React,
  elementClass: PageEditor,
});

export const LitDocTitle = createReactComponentFromLit({
  react: React,
  elementClass: DocTitle,
});

export const LitEdgelessEditor = createReactComponentFromLit({
  react: React,
  elementClass: EdgelessEditor,
});

export const LitDatabaseFullscreenEditor = createReactComponentFromLit({
  react: React,
  elementClass: DatabaseFullscreenEditor,
});

function safeDefine(name: string, ctor: CustomElementConstructor) {
  if (!customElements.get(name)) {
    customElements.define(name, ctor);
  }
}

export function editorEffects() {
  if (typeof customElements === 'undefined') return;
  safeDefine('page-editor', PageEditor);
  safeDefine('edgeless-editor', EdgelessEditor);
  safeDefine('database-fullscreen-editor', DatabaseFullscreenEditor);
}

// React wrappers construct the HTMLElement class directly. Register the exact
// constructors whenever this barrel is imported, including Planner-only pages
// that do not load the full BlockSuite editor bootstrap first.
editorEffects();
